export default __webpack_public_path__ + "static/media/community-shape.5a26e859.svg";